import DefaultSlider from "./default-slider";

const SlideBanner = () => {
    return (
        <DefaultSlider />
    );
};

export default SlideBanner;